/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/sort-comp */
/* eslint-disable react/require-optimization */
import React from "react"; // React Native needs this import
import {
  Component,
  createElement,
  createContext,
  ReactElement,
  ReactNode,
} from "react";
import { ResourceError } from "./Errors";

// This isn't suffient but hard to properly type
// eslint-disable-next-line @typescript-eslint/ban-types
export type ErrorConstructor = Function;
export type Reset = () => void;
export type FallbackProps = {
  reset: Reset;
  error: Error;
};
export type Fallback<T = {}> = (
  props: FallbackProps & T
) => ReactElement<any, any> | null;

export const ErrorContext = createContext<FallbackProps>({
  reset: () => {},
  error: new Error(),
});

class ErrorBoundary<T = {}> extends Component<
  {
    fallbackProps: T;
    fallback: Fallback<T> | Map<ErrorConstructor | undefined, Fallback<T>>;
    children: ReactNode;
    shouldLog?: (error: Error) => boolean;
  },
  { error: Error | null }
> {
  static defaultProps = { fallbackProps: {} };

  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    if (
      "rg4js" in window &&
      (this.props.shouldLog === undefined || this.props.shouldLog(error))
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.rg4js("send", {
        error,
      });
    }
  }

  render() {
    const { error } = this.state;
    const { reset } = this;
    if (!error) {
      return this.props.children;
    }

    // eslint-disable-next-line prefer-const
    let { fallback, fallbackProps } = this.props;
    if (fallback instanceof Map) {
      // Find the first matching error type
      const maybeFallback = fallback.get(
        Array.from(fallback.keys()).find(
          (constructor) =>
            constructor !== undefined && error instanceof constructor
        )
      );
      if (!maybeFallback) {
        throw error;
      }
      fallback = maybeFallback;
    }

    const value = { reset, error, ...fallbackProps };

    return (
      <ErrorContext.Provider value={value}>
        {createElement(fallback, value)}
      </ErrorContext.Provider>
    );
  }

  reset: Reset = () => {
    const { error } = this.state;
    if (error instanceof ResourceError) {
      error.clear();
    }
    this.setState({ error: null });
  };
}

export default ErrorBoundary;
